//@ts-ignore;
export const cx = (...classes) => classes.filter(a => !!a).join(' ')
export const hover = (string: string) =>
  string
    .split(' ')
    .map(s => `hover:${s}`)
    .join(' ')
export const active = (string: string) =>
  string
    .split(' ')
    .map(s => `active:${s}`)
    .join(' ')
export const focus = (string: string) =>
  string
    .split(' ')
    .map(s => `focus:${s}`)
    .join(' ')
export const tablet = (string: string) =>
  string
    .split(' ')
    .map(s => `max-md:${s}`)
    .join(' ')

// 미디어 쿼리 헬퍼 함수들
type MediaQuery =
  | 'sm'
  | 'md'
  | 'lg'
  | 'xl'
  | '2xl'
  | 'max-sm'
  | 'max-md'
  | 'max-lg'
  | 'max-xl'
  | 'max-2xl'

export const media = (query: MediaQuery, classes: string[]): string => {
  return classes
    .flatMap(cls =>
      // 각 문자열을 공백으로 분할하여 개별 클래스들을 추출
      cls.trim().split(/\s+/).filter(Boolean)
    )
    .map(cls => `${query}:${cls}`)
    .join(' ')
}

export const stylebook = {
  button: {
    primary: 'py-2 px-4 bg-gray-0 text-green-50 bold h6 flex items-center justify-between gap-2',
    secondary:
      'py-2 px-4 bg-gray-100 text-gray-50 bold h6 flex items-center justify-between gap-2 hover:bg-gray-95 transition-all duration-300 ease-in-out',
  },
  film: {
    contentBox:
      'pl-marg pt-gutter w-1/2 pr-14 pb-24 2xl:pb-30 4xl:pb-48 max-md:w-full max-md:pb-17 max-md:pr-marg max-md:mt-14 max-md:first:mt-0',
  },
}

// 더 직관적인 별칭들
// export const mobile = (classes: string[]): string => media('max-md', classes)
// export const tablet = (classes: string[]): string => media('md', classes)
// export const desktop = (classes: string[]): string => media('lg', classes)
// export const largeDesktop = (classes: string[]): string => media('xl', classes)

// // 범위 미디어 쿼리 (mobile only, tablet only 등)
// export const mobileOnly = (classes: string[]): string => media('max-md', classes)
// export const tabletOnly = (classes: string[]): string => {
//   return classes.map(cls => `md:${cls} lg:hidden`).join(' ')
// }
// export const desktopOnly = (classes: string[]): string => media('lg', classes)
